// extracted by mini-css-extract-plugin
export default {"uploader":"styles_uploader__7lDMT","header":"styles_header__nxU7C","filesContainer":"styles_filesContainer__2bSKS","closed":"styles_closed__zlvWr"};